<!-- 静态页面-->
<template>
	<div class="container">
		<el-container v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
			<el-header class="header">
				<div class="logo">
					<span>
						店铺管理系统 V2.0.0
					</span>
					<el-menu mode="horizontal" router background-color="#303133" text-color="#fff"
						active-text-color="#ffd04b">
						<el-submenu index="name">
							<template slot="title"><i class="iconfont">&#xe611;</i>{{name}}</template>
							<el-menu-item :index="'/User/pass.html'">修改密码</el-menu-item>
						</el-submenu>
						<el-menu-item @click="logout"><i class="iconfont">&#xe606;</i>退出</el-menu-item>
					</el-menu>
				</div>
			</el-header>
			<el-container>
				<el-aside class="aside" width="200px" :style="menuHeight" v-if="menuLoad">
					<el-menu background-color="#606266" router text-color="#fff" active-text-color="#ffd04b">
						<template>
							<el-submenu index="a">
								<template slot="title">
									<i class="iconfont">&#xe618;</i>系统设置
								</template>
								<el-menu-item :index="'/Role/index.html'">
									<i class="iconfont">&#xe702;</i>角色管理
								</el-menu-item>
								<el-menu-item :index="'/User/index.html'">
									<i class="iconfont">&#xe702;</i>管理员管理
								</el-menu-item>
								<el-menu-item :index="'/Pay/index.html'">
									<i class="iconfont">&#xe702;</i>支付配置
								</el-menu-item>
								<el-menu-item :index="'/Settings/applet.html'">
									<i class="iconfont">&#xe702;</i>小程序参数配置
								</el-menu-item>
								<el-menu-item :index="'/Settings/freight.html'">
									<i class="iconfont">&#xe702;</i>运费配置
								</el-menu-item>
								<el-menu-item :index="'/Settings/expressapi.html'">
									<i class="iconfont">&#xe702;</i>物流查询
								</el-menu-item>
							</el-submenu>
							<el-submenu index="b" v-auth="['store/diy']">
								<template slot="title">
									<i class="iconfont">&#xe618;</i>店铺装修
								</template>
								<el-menu-item :index="'/ShoppingMall/swiper.html'" v-auth="['store/fitment.swiper/list']">
									<i class="iconfont">&#xe702;</i>轮播图
								</el-menu-item>
								<el-menu-item :index="'/ShoppingMall/bgset.html'" v-auth="['store/setting/bgset']">
									<i class="iconfont">&#xe702;</i>底图设置
								</el-menu-item>
							</el-submenu>
							<el-submenu index="c" v-auth="['store/product']">
								<template slot="title">
									<i class="iconfont">&#xe6e9;</i>商品管理
								</template>
								<el-menu-item :index="'/Category/index.html'" v-auth="['store/productCategory/listTreeByPid']">
									<i class="iconfont">&#xe702;</i>商品分类
								</el-menu-item>
								<el-menu-item :index="'/Goods/index.html'" v-auth="['store/product/listOnSale']">
									<i class="iconfont">&#xe702;</i>在售商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/off.html'" v-auth="['store/product/listOff']">
									<i class="iconfont">&#xe702;</i>下架商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/find.html'" v-auth="['store/product/listFind']">
									<i class="iconfont">&#xe702;</i>热门商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/terrace.html'" v-auth="['store/product/listSupplierProduct']">
									<i class="iconfont">&#xe702;</i>产品库商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/own.html'" v-auth="['store/Goods/index']">
									<i class="iconfont">&#xe702;</i>自有商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/unreviewed.html'" v-auth="['store/Goods/index']">
									<i class="iconfont">&#xe702;</i>待审核-商品
								</el-menu-item>
								<el-menu-item :index="'/Goods/reject.html'" v-auth="['store/Goods/index']">
									<i class="iconfont">&#xe702;</i>被驳回-商品
								</el-menu-item>
							</el-submenu>
							<el-submenu index="d" v-auth="['store/member']">
								<template slot="title">
									<i class="iconfont">&#xe617;</i>会员管理
								</template>
								<el-menu-item :index="'/Member/MemberList.html'" v-auth="['store/member/list']">
									<i class="iconfont">&#xe702;</i>会员列表
								</el-menu-item>
								<el-menu-item :index="'/Member/jifen.html'" v-auth="['store/member.jifen/listImport']"><i class="iconfont">&#xe702;</i>积分管理
								</el-menu-item>
								<el-menu-item :index="'/Member/MemberLevel.html'" v-auth="['store/member.level/list']">
									<i class="iconfont">&#xe702;</i>会员级别
								</el-menu-item>
								<el-menu-item :index="'/Member/integral.html'" v-auth="['store/member.jifen/list']">
									<i class="iconfont">&#xe702;</i>积分明细
								</el-menu-item>
							</el-submenu>
							<el-submenu index="e" v-auth="['store/stock']">
								<template slot="title">
									<i class="iconfont">&#xe680;</i>库存管理
								</template>
								<el-menu-item :index="'/Repertory/index.html'" v-auth="['store/stock/listStock']">
									<i class="iconfont">&#xe702;</i>商品库存
								</el-menu-item>
								<el-menu-item :index="'/Repertory/outInwarehouse.html'" v-auth="['store/stock/addStockIn']">
									<i class="iconfont">&#xe702;</i>商品入库
								</el-menu-item>
								<el-menu-item :index="'/Repertory/in.html'" v-auth="['store/stock/listStockIn']">
									<i class="iconfont">&#xe702;</i>入库查询
								</el-menu-item>
								<el-menu-item :index="'/Repertory/out.html'" v-auth="['store/stock/listStockOut']">
									<i class="iconfont">&#xe702;</i>出库查询
								</el-menu-item>
							</el-submenu>
							<el-submenu index="f" v-auth="['store/order']">
								<template slot="title">
									<el-badge :value="count.new_order_count + count.refunding_count" class="item">
										<i class="iconfont">&#xe642;</i>订单管理
									</el-badge>
								</template>
								<el-menu-item :index="'/Indent/index.html'" v-auth="['store/order/list']">
									<el-badge :value="count.new_order_count" class="item">
										<i class="iconfont">&#xe702;</i>订单汇总
									</el-badge>
								</el-menu-item>
								<el-menu-item :index="'/Indent/complete.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>自营订单
								</el-menu-item>
								<el-menu-item :index="'/Indent/unfinished.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>非自营订单
								</el-menu-item>
								<el-menu-item :index="'/Indent/dropShipping.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>待发货
								</el-menu-item>
								<el-menu-item :index="'/Indent/forGoods.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>待收货
								</el-menu-item>
								<el-menu-item :index="'/Indent/completed.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>已完成
								</el-menu-item>
								<el-menu-item :index="'/Refund/index.html'" v-auth="['store/order.refund/list']">
									<el-badge :value="count.refunding_count" class="item">
										<i class="iconfont">&#xe702;</i>售后管理
									</el-badge>
								</el-menu-item>
								<el-menu-item :index="'/invoice/index.html'" v-auth="['store/order.invoice/list']">
									<el-badge class="item">
										<i class="iconfont">&#xe702;</i>发票管理
									</el-badge>
								</el-menu-item>
							</el-submenu>
							<el-submenu index="g">
								<template slot="title">
									<i class="iconfont">&#xe617;</i>装修
								</template>
								<el-menu-item :index="'/page/index.html'">
									<i class="iconfont">&#xe702;</i>装修管理
								</el-menu-item>
							</el-submenu>
							<el-submenu index="g" v-auth="['store/app']">
								<template slot="title">
									<i class="iconfont">&#xe617;</i>营销管理
								</template>
								<el-menu-item :index="'/app/index.html'" v-auth="['store/app/index']">
									<i class="iconfont">&#xe702;</i>营销列表
								</el-menu-item>
							</el-submenu>
							<el-menu-item index="/Finance/index.html" v-auth="['store/Finance/index']">
								<i class="iconfont">&#xe633;</i>对账单
							</el-menu-item>
						</template>
					</el-menu>
				</el-aside>
				<el-container>
					<el-main :style="mainHeight">
						<transition name="el-fade-in-linear">
							<router-view v-if="menuLoad" class="router-view"></router-view>
						</transition>
					</el-main>
					<el-footer height="40px">
					</el-footer>
				</el-container>
			</el-container>
		</el-container>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mainHeight: {
				height: ""
			},
			menuHeight: {
				height: "",
				"overflow-x": "hidden",
			},
			isLoad: false,
			menu: [],
			user:{},
			name: localStorage.login_name,
			menuLoad: false,
			count: {}
		}
	},
	watch: {
		$route: function (e) {
			this.loadMain();
		}
	},
	created() {
		window.addEventListener("resize", this.setHeight);
		this.setHeight();
		this.loadMenu()
		this.loadData()
	},
	mounted() {
		this.loadMain()
	},
	methods: {
		loadMain: function () {
			//获取统计信息
			this.axios.get('store/data/count').then(res => {
				this.count = res.data.count
			}).catch((res) => {

			})
		},
		loadMenu(val){
			this.axios.get('store/data/menus').then(res => {
				this.menuLoad = true
				this.$store.dispatch('admin/user/set', {
					user: res.data.user,
					access: res.data.menus,
				});
			}).catch(() => {
			})
		},
		setHeight() {
			this.mainHeight.height = window.innerHeight - 100 + "px";
			this.menuHeight.height = window.innerHeight - 60 + "px";
		},
		loadData() {
			this.isLoad = !this.isLoad
			this.axios.get('store/data/menus').then(res => {
				this.isLoad = !this.isLoad
				this.user = res.data.user
				this.menu = res.data.menus
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		logout() {
			localStorage.clear();
			this.$message.success({
				message: '退出成功'
			});
			this.$router.replace({
				path: '/Login.html'
			});
		}
	}
}
</script>
<style scoped>
	.el-menu-item.is-active {
		background-color: #444444 !important;
	}

	.iconfont {
		vertical-align: middle;
		margin-right: 5px;
		margin-top: -4px;
		width: 24px;
		text-align: center;
		font-size: 18px;
		color: rgb(255, 255, 255);
	}

	.main {
		min-height: 100%;
		padding: 20px;
	}

	.el-main {
		padding: 0;
	}

	.container .header {
		background: #303133;
	}

	.container .el-menu {
		height: 100%;
		border: none;
	}

	.container .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.container .logo span {
		color: rgb(255, 208, 75);
		font-size: 18px;
	}

	.container .el-footer {
		background-color: #DCDFE6;
		align-items: center;
		display: flex;
	}
	.aside::-webkit-scrollbar{display:none;}
</style>
